import pagesContractorCoreInstanceEn from "./instance/default";
import pagesContractorCoreOperationPackagesEn from "./operation-packages/default";

export default {
  operationPackages: pagesContractorCoreOperationPackagesEn,
  instance: pagesContractorCoreInstanceEn,
};
